import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import getUniqueAttendees from 'owa-calendar-forms-common/lib/utils/getUniqueAttendees';
import { freeBusyCache, isConflictFromFreeBusy } from 'owa-freebusy-cache';
import type { OwaDate } from 'owa-datetime';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { lazyGetRoomFreeBusy } from 'owa-room-selection';

/**
 * Gets the conflict count for a collection of attendees and start/end times
 * @param resources The resource Collection
 * @param start Start time
 * @param end End time
 * @param isAllDay: is all day
 * @param recurrence: the event recurrence
 * @param originalEvent: An optional CalendarEvent to filter out of the results
 */
export default function getResourceConflictCount(
    resources: AttendeeType[],
    start: OwaDate,
    end: OwaDate,
    isAllDay: boolean,
    recurrence: RecurrenceType,
    requiredAttendees: AttendeeType[],
    optionalAttendees: AttendeeType[],
    originalEvent?: CalendarEvent
) {
    return lazyGetRoomFreeBusy.import().then(getRoomFreeBusy => {
        const calendarEventTime = {
            Start: start,
            End: end,
            IsAllDayEvent: isAllDay,
            Recurrence: recurrence,
            RequiredAttendees: requiredAttendees,
            OptionalAttendees: optionalAttendees,
        };

        return getUniqueAttendees(resources)
            .map(
                resource =>
                    getRoomFreeBusy(
                        resource.Mailbox.EmailAddress,
                        freeBusyCache,
                        calendarEventTime,
                        null /* bookingType */,
                        originalEvent
                    ).freeBusyState
            )
            .filter(freeBusy => isConflictFromFreeBusy(freeBusy)).length;
    });
}
